module.exports = __webpack_public_path__ + "static/media/E_SDG_logo.3d37ecf1.png";